import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { isBefore, parseISO } from 'date-fns';
import { useEffect, useState } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { Button, Container, Content, DatePicker, FlexboxGrid, HelpBlock, Input, InputGroup } from 'rsuite';
import { LoadingSpiner } from '../../../../../components/LoadingSpinner';
import Modal from '../../../../../components/NewModalConfirmacao';
import { CampaignTypeSelect } from '../../Components/CampaignTypeSelect/CampaignTypeSelect';
import Steps from '../Components/Steps';
import { getLojasParticipantes } from '../LojasParticipantes/services';
import { getCampaign } from '../services';
import { saveCampanha, updateCampanha } from './services';

const DeleteMessage = () => (
  <>
    <p>Ao voltar, você perderá os dados preenchidos nessa etapa. Para salvar os dados prossiga para Escolher Lojas.</p>
    <br />
    <p>Você confirma que deseja voltar?</p>
  </>
);

const DadosCampanha = ({ history }) => {
  const { id } = useParams();
  const [showModalDescartarCampanha, setShowModalDescartarCampanha] = useState(false);
  const [campanha, setCampanha] = useState({
    name: '',
    starting_date: null,
    expiration_date: null,
    author: JSON.parse(localStorage.getItem('usuario'))?.email,
    client_id: JSON.parse(localStorage.getItem('cliente'))?.codigo,
    status: 'DRAFT',
    campaign_type: null,
  });
  const [errors, setErrors] = useState({});
  const [lojasParticipantes, setLojasParticipantes] = useState({
    content: [],
  });
  const isCampaignReadOnly = campanha.status === 'CURRENT' || campanha.status === 'CLOSED';

  const back = () => {
    history.push('/ipa/campanhas');
  };

  const closeDescartar = () => {
    setShowModalDescartarCampanha(false);
  };

  const validForm = () => {
    const errors = {};
    let formIsValid = true;

    if (!campanha.name) {
      formIsValid = false;
      errors.name = 'Campo obrigatório';
    }

    if (!campanha.starting_date) {
      formIsValid = false;
      errors.starting_date = 'Campo obrigatório';
    }

    if (!campanha.expiration_date) {
      formIsValid = false;
      errors.expiration_date = 'Campo obrigatório';
    }

    if (!campanha.campaign_type) {
      formIsValid = false;
      errors.campaign_type = 'Campo obrigatório';
    }

    setErrors(errors);
    return formIsValid;
  };

  const createCampanha = async () => {
    let response = null;

    const { campaign_type, ...rest } = campanha;
    const dadosCampanha = {
      ...rest,
      campaign_type_id: campaign_type.id,
      offers: [],
      stores: [],
    };
    if (isCampaignReadOnly) {
      history.push(`/ipa/campanhas/cadastro/blocos-de-oferta/${id}`);
    } else if (validForm()) {
      if (id) {
        response = await updateCampanha(dadosCampanha);
      } else {
        response = await saveCampanha(dadosCampanha);
      }
      if (response?.campaign_id) {
        history.push(`/ipa/campanhas/cadastro/blocos-de-oferta/${response.campaign_id}`);
      }
    }
  };

  const listCampaign = async () => {
    const response = await getCampaign(id);
    response.data.starting_date = parseISO(response.data.starting_date);
    response.data.expiration_date = parseISO(response.data.expiration_date);
    response.data.campaign_type = {
      id: response.data.campaign_type_id,
      label: response.data.campaign_type,
      order: response.data.campaign_type_order,
      value: response.data.campaign_type_order?.toString(),
    };
    setCampanha(oldState => ({ ...oldState, ...response.data }));
    const fromTab = history.location?.state?.fromTab;
    const hasOffers = response.data.hasOffer;
    if (!fromTab && hasOffers) {
      history.push(`/ipa/campanhas/cadastro/ofertas/${id}`);
    }
  };

  const listLojasParticipantes = async () => {
    const response = await getLojasParticipantes({
      id,
      page: 0,
      size: 20,
    });
    if (response) setLojasParticipantes(response);
  };

  useEffect(() => {
    if (id) {
      listCampaign();
      listLojasParticipantes();
    }
  }, [id]);

  useEffect(() => {
    Object.keys(campanha).forEach(key => {
      if (campanha[key]) {
        setErrors(oldState => ({ ...oldState, [key]: '' }));
      }
    });
  }, [campanha]);

  return (
    <Container className="main-container cadastro-dados-campanha-page">
      <Steps rota={history.location.pathname} campanhaId={id} status={campanha?.status} lojas={lojasParticipantes?.content?.length} />
      <Content className="dados-campanha-header">
        <LoadingSpiner size="md" />
        <FlexboxGrid>
          <FlexboxGrid.Item colspan={24}>
            <FlexboxGrid>
              <FlexboxGrid.Item colspan={24}>
                <h2>Dados da campanha</h2>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item colspan={24}>
                <FlexboxGrid className="dados-campanha-form-container">
                  <FlexboxGrid.Item colspan={8}>
                    <div className="dados-campanha-input-container">
                      <span className="label">Nome da Campanha</span>
                      <InputGroup inside className="input-outline-no-icon">
                        <Input
                          id="dados-campanha-input"
                          value={campanha.name}
                          disabled={isCampaignReadOnly}
                          onChange={value =>
                            setCampanha(oldState => ({
                              ...oldState,
                              name: value,
                            }))
                          }
                        />
                        {errors.name ? <HelpBlock style={{ color: 'red' }}>{errors.name}</HelpBlock> : null}
                      </InputGroup>
                    </div>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item colspan={8}>
                    <div className="dados-campanha-input-container">
                      <span className="label">Tipo de Campanha</span>
                      <InputGroup inside className="input-outline-no-icon">
                        <CampaignTypeSelect
                          item={campanha.campaign_type}
                          searchable={false}
                          disabled={isCampaignReadOnly}
                          onSelect={value =>
                            setCampanha(oldState => ({
                              ...oldState,
                              campaign_type: value,
                            }))
                          }
                        />
                        {errors.campaign_type ? <HelpBlock style={{ color: 'red' }}>{errors.campaign_type}</HelpBlock> : null}
                      </InputGroup>
                    </div>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item>
                    <div className="dados-campanha-input-container">
                      <span className="label">Início de Circulação</span>
                      <DatePicker
                        id="dados-campanha-data-inicio"
                        oneTap
                        className="data-campanha"
                        format="DD/MM/YYYY"
                        disabled={isCampaignReadOnly}
                        disabledDate={date => isBefore(date, new Date())}
                        value={campanha.starting_date}
                        onChange={value =>
                          setCampanha(oldState => ({
                            ...oldState,
                            starting_date: value,
                          }))
                        }
                      />
                      {errors.starting_date ? <HelpBlock style={{ color: 'red' }}>{errors.starting_date}</HelpBlock> : null}
                    </div>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item>
                    <div className="dados-campanha-input-container">
                      <span className="label">Final de Circulação</span>
                      <DatePicker
                        id="dados-campanha-data-final"
                        oneTap
                        format="DD/MM/YYYY"
                        disabled={isCampaignReadOnly}
                        disabledDate={date => (campanha.starting_date ? isBefore(date, campanha.starting_date) : isBefore(date, new Date()))}
                        className="data-campanha"
                        value={campanha.expiration_date}
                        onChange={value =>
                          setCampanha(oldState => ({
                            ...oldState,
                            expiration_date: value,
                          }))
                        }
                      />
                      {errors.expiration_date ? <HelpBlock style={{ color: 'red' }}>{errors.expiration_date}</HelpBlock> : null}
                    </div>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Content>
      <Content className="navegacao-dados-campanha">
        <FlexboxGrid justify="space-between">
          <FlexboxGrid.Item>
            <Button appearance="link" onClick={() => (id ? back() : setShowModalDescartarCampanha(true))}>
              <ArrowBackIcon /> Voltar para campanhas
            </Button>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item>
            <Button id="dados-campanha-next" appearance="primary" onClick={createCampanha}>
              <ArrowForwardIcon />{' '}
              {isCampaignReadOnly ? 'BLOCOS DE OFERTAS' : id ? 'ATUALIZAR CAMPANHA' : 'CRIAR CAMPANHAS'}
            </Button>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Content>
      <Modal
        show={showModalDescartarCampanha}
        onConfirm={back}
        onCancel={closeDescartar}
        title="Descartar campanha"
        message={DeleteMessage()}
        confirmButton="Confirmar"
        cancelButton="Cancelar"
      />
    </Container>
  );
};

export default withRouter(DadosCampanha);
